import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from 'react';

/**
 * Determines how the details panel is rendered relative to the content.
 * @public
 */
export type LayoutMode = 'split' | 'overlay';

/** @internal */
export type RenderedLayout = 'split' | 'collapsed' | 'overlay' | 'drawer';

/** @internal */
export interface DetailsLayoutContextValue {
  collapsed: boolean;
  setCollapsed: Dispatch<SetStateAction<boolean>>;
  preferredLayout: LayoutMode;
  setPreferredLayout: Dispatch<SetStateAction<LayoutMode>>;
  mode: RenderedLayout;
}

/** @internal */
export const DetailsLayoutContext =
  createContext<DetailsLayoutContextValue | null>(null);

/** @internal */
export function useDetailsLayoutContext() {
  return useContext(DetailsLayoutContext);
}
